<template>
	<div style="background: #fff;">
			<div class="row main-nav">
				<div class="nav-title" >
					<img src="../../assets/img/logo.png" style="width: 200px;" />
				</div>
				<div>
					<Menu mode="horizontal" @on-select="route" activeName="1" v-if="active==1">
				        <Menu-item name="1">				            
							首 页
				        </Menu-item>
				        <Menu-item name="2">				            
				         	产 品
				        </Menu-item>
				        <Menu-item name="3">				            
				           	关于我们
				        </Menu-item>
				        <Menu-item name="4">			            
				           	客户服务
				        </Menu-item>
			       </Menu>
			       <Menu mode="horizontal" @on-select="route" activeName="2" v-if="active==2">
				        <Menu-item name="1">				            
							首 页
				        </Menu-item>
				        <Menu-item name="2">				            
				         	产 品
				        </Menu-item>
				        <Menu-item name="3">				            
				           	关于我们
				        </Menu-item>
				        <Menu-item name="4">			            
				           	客户服务
				        </Menu-item>
			       </Menu>
			       <Menu mode="horizontal" @on-select="route" activeName="3" v-if="active==3">
				        <Menu-item name="1">				            
							首 页
				        </Menu-item>
				        <Menu-item name="2">				            
				         	产 品
				        </Menu-item>
				        <Menu-item name="3">				            
				           	关于我们
				        </Menu-item>
				        <Menu-item name="4">			            
				           	客户服务
				        </Menu-item>
			       </Menu>
			       <Menu mode="horizontal" @on-select="route" activeName="4" v-if="active==4">
				        <Menu-item name="1">				            
							首 页
				        </Menu-item>
				        <Menu-item name="2">				            
				         	产 品
				        </Menu-item>
				        <Menu-item name="3">				            
				           	关于我们
				        </Menu-item>
				        <Menu-item name="4">			            
				           	客户服务
				        </Menu-item>
			       </Menu>
				</div>
				<div class="col nav-right" style="justify-content: center;" >
					<div class="row" style="align-items: center;justify-content: flex-end;">
						<img src="../../assets/img/u12.jpg" style="cursor: pointer;width: 36px;" @click="toIndex"/>
						|
						<img src="../../assets/img/u13.jpg" style="cursor: pointer;width: 36px;" @click="out"/>
					</div>
					<div class="row" style="justify-content: flex-end;">
						<img src="../../assets/img/u10.png" style="width: 75px;" />
					</div>
				</div>
			</div>
			<div class="phone-nav">
				<Dropdown trigger="click" style="margin-left: 20px" @on-click="route">
			       	<div class="row" style="align-items: center;">
			       		<Icon type="md-menu" size="24" color="#999" />
			       		<span style="color: #999;">菜单栏</span>
			       	</div>					
			        <DropdownMenu slot="list" >
			            <DropdownItem name='1'>首页</DropdownItem>
			            <DropdownItem name='2'>产品</DropdownItem>
			            <DropdownItem name='3'>关于我们</DropdownItem>
			            <DropdownItem name='4'>客户服务</DropdownItem>
			        </DropdownMenu>
			    </Dropdown>
				
			</div>
		</div>
</template>

<script>
	export default {
		name: 'App',

		data() {
			return {
				modal5: false,
				active:''
			}
		},
		created(){
			if(this.$route.meta.name){
				this.active=this.$route.meta.name
			}
					
		},
		methods: {
			route(name){
				
				if(name==3){
					this.$router.push('aboutus')
				}else if(name==1){
					this.$router.push('index')
				}else if(name==2){
					this.$router.push('product')
				}else if(name==4){
					this.$router.push('customer')
				}
				
			},
			toIndex(){
				this.$router.push('index')	
			},
			out(){
				window.open("http://www.tomal.se/eng/index.php"); 
			}
		},
		mounted() {

		}
	}
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		display: block;
		position: absolute;
		background: #FFF;
	}
	
	
	@media screen and (max-width: 980px) {
	    .center-body{	    	
	    	width: 100%;
	    	
	    }
	    .main-nav{
	    	display: none;
	    }
	    .phone-nav{
	    	position: absolute;
	    	top: 10px;
	    	right: 10px;
	    }
	   
	}
	@media screen and (min-width: 980px) {
	     .main-nav{
	     	margin: 0 auto;
	     	width: 980px;
	    	
	    }
	    .phone-nav{
	    	display: none;
	    	
	    }
	    .nav-title{
	    	height: 75px;
	    	width: 200px;
	    	padding-top: 10px;
	    	text-align: center;
	    	flex: none;
	    	border-bottom: 1px solid #dcdee2;
	    	
	    }
	    
	    .nav-right{	    	
	    	height: 75px;
	    	border-bottom: 1px solid #dcdee2;
	    	
	    }
	    .ivu-menu-item{
	    	width: 120px;
	    	text-align: center;
	    }
	  
	}
</style>